<template>
  <el-row class="early-bird-paystub" :gutter="18">
    <el-col :span="22" :offset="1" v-if="showEmptyState">
      <h4 class="text-uppercased">Paystubs</h4>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <h3 class="ma-0">Does the client have a W-2?</h3>
        </div>
        <p>
          If the client has a W-2
          <strong>or is filing with Schedule-C only</strong>, click the "Yes, My Client has ALL of their W-2s" button. Otherwise, click "Add Paystub" to convert the client's paystubs into W-2s to prepare a tax refund estimate.
        </p>
        <p>
          <el-button type="primary" size="large" @click="skipPaystubStep">Yes, the client has ALL of their W-2s.</el-button>
          <el-button type="primary" size="large" @click="showEmptyState = false">Add Paystub(s)</el-button>
        </p>
      </el-card>
    </el-col>
    <el-col :span="22" :offset="1" v-if="!showEmptyState">
      <h4 class="text-uppercased">Paystubs <el-button type="primary" icon="plus" @click="addPaystub">Add Paystub</el-button></h4>
      <paystub-table :paystubs="paystubs" @edit="editPaystub"></paystub-table>
    </el-col>
    <el-dialog
      title="Edit Paystub"
      :visible.sync="editPaystubDialogVm.visible"
      size="small">
      <edit-paystub-dialog :paystub="editPaystubDialogVm.paystub" @close="closeEditPaystubDialog"></edit-paystub-dialog>
    </el-dialog>
  </el-row>
</template>

<script>
import { mapGetters } from 'vuex';
import EditPaystubDialog from '@/components/dialog-content/EditPaystub.vue';
import PaystubTable from '@/components/tables/Paystub.vue';

export default {
  name: 'eb-paystub',
  data() {
    return {
      editPaystubDialogVm: {
        visible: false,
        paystub: null,
      },
      showEmptyState: false,
    };
  },
  methods: {
    skipPaystubStep() {
      this.$emit('nextStep', 2);
    },
    addPaystub() {
      this.editPaystubDialogVm.paystub = null;
      this.editPaystubDialogVm.visible = true;
    },
    editPaystub(paystub) {
      this.editPaystubDialogVm.paystub = paystub;
      this.editPaystubDialogVm.visible = true;
    },
    closeEditPaystubDialog() {
      this.editPaystubDialogVm.visible = false;
      this.editPaystubDialogVm.paystub = null;
    },
  },
  computed: {
    ...mapGetters('Client', [
      'paystubs',
    ]),
  },
  mounted() {
    this.showEmptyState = this.paystubs.length === 0;
  },
  components: {
    EditPaystubDialog,
    PaystubTable,
  },
};

</script>

<style lang="scss" scoped>

.early-bird-paystub {
  h4 {
    display: flex;
    align-items: center;

    button {
      margin-left: auto;
    }
  }
}

</style>
